import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Box } from '../../Box/Box.js';
import { Crossout as CrossoutMemoized } from '../Crossout/Crossout.js';
import { DiscountBadge as DiscountBadgeMemoized } from '../DiscountBadge/DiscountBadge.js';
import { FinalRate as FinalRateMemoized } from '../FinalRate/FinalRate.js';
import { Typography } from '../../Typography/Typography.js';

var _excluded = ["finalRate", "discountBadge", "crossOut", "shadowPrice", "priceCaption"];
/** Price is used to display the total cost on an Agoda listing. Prices and discount rates provided will typically be displayed vertically. */
var Price = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var finalRate = _ref.finalRate,
    discountBadge = _ref.discountBadge,
    crossOut = _ref.crossOut,
    shadowPrice = _ref.shadowPrice,
    priceCaption = _ref.priceCaption,
    rest = _objectWithoutProperties(_ref, _excluded);
  var discountBadgeElement = discountBadge &&
  /*#__PURE__*/
  // Need to wrap within a Box to override Badge align-self
  React.createElement(Box, {
    alignSelf: "flex-end"
  }, /*#__PURE__*/React.createElement(DiscountBadgeMemoized, _extends({
    mb: "4"
  }, discountBadge)));

  // Do not flip currency for shadow price
  var shadowPriceElement = shadowPrice && /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    dir: "ltr"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-default",
    textColor: "base.subtle",
    mb: "4"
  }, shadowPrice));
  return /*#__PURE__*/React.createElement(Box, _extends({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    ref: ref
  }, rest), discountBadgeElement, crossOut && /*#__PURE__*/React.createElement(CrossoutMemoized, _extends({
    srOnlyLeadingText: crossOut.srOnlyLeadingText,
    mb: "4"
  }, crossOut)), /*#__PURE__*/React.createElement(FinalRateMemoized, _extends({
    mb: "4"
  }, finalRate)), shadowPriceElement, priceCaption && /*#__PURE__*/React.createElement(Typography, {
    variant: "caption-default",
    textColor: "base.subtle"
  }, priceCaption));
});
var PriceMemoized = /*#__PURE__*/React.memo(Price);
PriceMemoized.displayName = 'Price';

export { PriceMemoized as Price };
//# sourceMappingURL=Price.js.map
